function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Plugin, MultiCommand, icons, Command } from '@ckeditor/ckeditor5-core/dist/index.js';
import { ButtonView, MenuBarMenuListItemButtonView } from '@ckeditor/ckeditor5-ui/dist/index.js';
import { addMarginRules } from '@ckeditor/ckeditor5-engine/dist/index.js';
import { first } from '@ckeditor/ckeditor5-utils/dist/index.js';
/**
 * The indent editing feature.
 *
 * This plugin registers the `'indent'` and `'outdent'` commands.
 *
 * **Note**: In order for the commands to work, at least one of the compatible features is required. Read more in the
 * {@link module:indent/indent~Indent indent feature} API documentation.
 */

var IndentEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(IndentEditing, _Plugin);

  var _super = _createSuper(IndentEditing);

  function IndentEditing() {
    _classCallCheck(this, IndentEditing);

    return _super.apply(this, arguments);
  }

  _createClass(IndentEditing, [{
    key: "init",
    value:
    /**
    * @inheritDoc
    */
    function init() {
      var editor = this.editor;
      editor.commands.add('indent', new MultiCommand(editor));
      editor.commands.add('outdent', new MultiCommand(editor));
    }
  }], [{
    key: "pluginName",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return 'IndentEditing';
    }
  }]);

  return IndentEditing;
}(Plugin);
/**
 * The indent UI feature.
 *
 * This plugin registers the `'indent'` and `'outdent'` buttons.
 *
 * **Note**: In order for the commands to work, at least one of the compatible features is required. Read more in
 * the {@link module:indent/indent~Indent indent feature} API documentation.
 */


var IndentUI = /*#__PURE__*/function (_Plugin2) {
  _inherits(IndentUI, _Plugin2);

  var _super2 = _createSuper(IndentUI);

  function IndentUI() {
    _classCallCheck(this, IndentUI);

    return _super2.apply(this, arguments);
  }

  _createClass(IndentUI, [{
    key: "init",
    value:
    /**
    * @inheritDoc
    */
    function init() {
      var editor = this.editor;
      var locale = editor.locale;
      var t = editor.t;
      var localizedIndentIcon = locale.uiLanguageDirection == 'ltr' ? icons.indent : icons.outdent;
      var localizedOutdentIcon = locale.uiLanguageDirection == 'ltr' ? icons.outdent : icons.indent;

      this._defineButton('indent', t('Increase indent'), localizedIndentIcon);

      this._defineButton('outdent', t('Decrease indent'), localizedOutdentIcon);
    }
    /**
    * Defines UI buttons for both toolbar and menu bar.
    */

  }, {
    key: "_defineButton",
    value: function _defineButton(commandName, label, icon) {
      var _this = this;

      var editor = this.editor;
      editor.ui.componentFactory.add(commandName, function () {
        var buttonView = _this._createButton(ButtonView, commandName, label, icon);

        buttonView.set({
          tooltip: true
        });
        return buttonView;
      });
      editor.ui.componentFactory.add('menuBar:' + commandName, function () {
        return _this._createButton(MenuBarMenuListItemButtonView, commandName, label, icon);
      });
    }
    /**
    * Creates a button to use either in toolbar or in menu bar.
    */

  }, {
    key: "_createButton",
    value: function _createButton(ButtonClass, commandName, label, icon) {
      var editor = this.editor;
      var command = editor.commands.get(commandName);
      var view = new ButtonClass(editor.locale);
      view.set({
        label: label,
        icon: icon
      });
      view.bind('isEnabled').to(command, 'isEnabled'); // Execute the command.

      this.listenTo(view, 'execute', function () {
        editor.execute(commandName);
        editor.editing.view.focus();
      });
      return view;
    }
  }], [{
    key: "pluginName",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return 'IndentUI';
    }
  }]);

  return IndentUI;
}(Plugin);
/**
 * The indent feature.
 *
 * This plugin acts as a single entry point plugin for other features that implement indentation of elements like lists or paragraphs.
 *
 * The compatible features are:
 *
 * * The {@link module:list/list~List} or {@link module:list/list/listediting~ListEditing} feature for list indentation.
 * * The {@link module:indent/indentblock~IndentBlock} feature for block indentation.
 *
 * This is a "glue" plugin that loads the following plugins:
 *
 * * The {@link module:indent/indentediting~IndentEditing indent editing feature}.
 * * The {@link module:indent/indentui~IndentUI indent UI feature}.
 *
 * The dependent plugins register the `'indent'` and `'outdent'` commands and introduce the `'indent'` and `'outdent'` buttons
 * that allow to increase or decrease text indentation of supported elements.
 *
 * **Note**: In order for the commands and buttons to work, at least one of compatible features is required.
 */


var Indent = /*#__PURE__*/function (_Plugin3) {
  _inherits(Indent, _Plugin3);

  var _super3 = _createSuper(Indent);

  function Indent() {
    _classCallCheck(this, Indent);

    return _super3.apply(this, arguments);
  }

  _createClass(Indent, null, [{
    key: "pluginName",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return 'Indent';
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "requires",
    get: function get() {
      return [IndentEditing, IndentUI];
    }
  }]);

  return Indent;
}(Plugin);
/**
 * The indent block command.
 *
 * The command is registered by the {@link module:indent/indentblock~IndentBlock} as `'indentBlock'` for indenting blocks and
 * `'outdentBlock'` for outdenting blocks.
 *
 * To increase block indentation at the current selection, execute the command:
 *
 * ```ts
 * editor.execute( 'indentBlock' );
 * ```
 *
 * To decrease block indentation at the current selection, execute the command:
 *
 * ```ts
 * editor.execute( 'outdentBlock' );
 * ```
 */


var IndentBlockCommand = /*#__PURE__*/function (_Command) {
  _inherits(IndentBlockCommand, _Command);

  var _super4 = _createSuper(IndentBlockCommand);

  /**
  * The command's indentation behavior.
  */

  /**
  * Creates an instance of the command.
  */
  function IndentBlockCommand(editor, indentBehavior) {
    var _this2;

    _classCallCheck(this, IndentBlockCommand);

    _this2 = _super4.call(this, editor);
    _this2._indentBehavior = void 0;
    _this2._indentBehavior = indentBehavior;
    return _this2;
  }
  /**
  * @inheritDoc
  */


  _createClass(IndentBlockCommand, [{
    key: "refresh",
    value: function refresh() {
      var editor = this.editor;
      var model = editor.model;
      var block = first(model.document.selection.getSelectedBlocks());

      if (!block || !this._isIndentationChangeAllowed(block)) {
        this.isEnabled = false;
        return;
      }

      this.isEnabled = this._indentBehavior.checkEnabled(block.getAttribute('blockIndent'));
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "execute",
    value: function execute() {
      var _this3 = this;

      var model = this.editor.model;

      var blocksToChange = this._getBlocksToChange();

      model.change(function (writer) {
        var _iterator = _createForOfIteratorHelper(blocksToChange),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var block = _step.value;
            var currentIndent = block.getAttribute('blockIndent');

            var nextIndent = _this3._indentBehavior.getNextIndent(currentIndent);

            if (nextIndent) {
              writer.setAttribute('blockIndent', nextIndent, block);
            } else {
              writer.removeAttribute('blockIndent', block);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
    /**
    * Returns blocks from selection that should have blockIndent selection set.
    */

  }, {
    key: "_getBlocksToChange",
    value: function _getBlocksToChange() {
      var _this4 = this;

      var model = this.editor.model;
      var selection = model.document.selection;
      var blocksInSelection = Array.from(selection.getSelectedBlocks());
      return blocksInSelection.filter(function (block) {
        return _this4._isIndentationChangeAllowed(block);
      });
    }
    /**
    * Returns false if indentation cannot be applied, i.e.:
    * - for blocks disallowed by schema declaration
    * - for blocks in Document Lists (disallowed forward indentation only). See https://github.com/ckeditor/ckeditor5/issues/14155.
    * Otherwise returns true.
    */

  }, {
    key: "_isIndentationChangeAllowed",
    value: function _isIndentationChangeAllowed(element) {
      var editor = this.editor;

      if (!editor.model.schema.checkAttribute(element, 'blockIndent')) {
        return false;
      }

      if (!editor.plugins.has('ListUtils')) {
        return true;
      } // Only forward indentation is disallowed in list items. This allows the user to outdent blocks that are already indented.


      if (!this._indentBehavior.isForward) {
        return true;
      }

      var documentListUtils = editor.plugins.get('ListUtils');
      return !documentListUtils.isListItemBlock(element);
    }
  }]);

  return IndentBlockCommand;
}(Command);
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
* @module indent/indentcommandbehavior/indentusingoffset
*/

/**
* The block indentation behavior that uses offsets to set indentation.
*/


var IndentUsingOffset = /*#__PURE__*/function () {
  /**
  * The direction of indentation.
  */

  /**
  * The offset of the next indentation step.
  */

  /**
  * Indentation unit.
  */

  /**
  * Creates an instance of the indentation behavior.
  *
  * @param config.direction The direction of indentation.
  * @param config.offset The offset of the next indentation step.
  * @param config.unit Indentation unit.
  */
  function IndentUsingOffset(config) {
    _classCallCheck(this, IndentUsingOffset);

    this.isForward = void 0;
    this.offset = void 0;
    this.unit = void 0;
    this.isForward = config.direction === 'forward';
    this.offset = config.offset;
    this.unit = config.unit;
  }
  /**
  * @inheritDoc
  */


  _createClass(IndentUsingOffset, [{
    key: "checkEnabled",
    value: function checkEnabled(indentAttributeValue) {
      var currentOffset = parseFloat(indentAttributeValue || '0'); // The command is always enabled for forward indentation.

      return this.isForward || currentOffset > 0;
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "getNextIndent",
    value: function getNextIndent(indentAttributeValue) {
      var currentOffset = parseFloat(indentAttributeValue || '0');
      var isSameUnit = !indentAttributeValue || indentAttributeValue.endsWith(this.unit);

      if (!isSameUnit) {
        return this.isForward ? this.offset + this.unit : undefined;
      }

      var nextOffset = this.isForward ? this.offset : -this.offset;
      var offsetToSet = currentOffset + nextOffset;
      return offsetToSet > 0 ? offsetToSet + this.unit : undefined;
    }
  }]);

  return IndentUsingOffset;
}();
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
* @module indent/indentcommandbehavior/indentusingclasses
*/

/**
* The block indentation behavior that uses classes to set indentation.
*/


var IndentUsingClasses = /*#__PURE__*/function () {
  /**
  * The direction of indentation.
  */

  /**
  * A list of classes used for indentation.
  */

  /**
  * Creates an instance of the indentation behavior.
  *
  * @param config.direction The direction of indentation.
  * @param config.classes A list of classes used for indentation.
  */
  function IndentUsingClasses(config) {
    _classCallCheck(this, IndentUsingClasses);

    this.isForward = void 0;
    this.classes = void 0;
    this.isForward = config.direction === 'forward';
    this.classes = config.classes;
  }
  /**
  * @inheritDoc
  */


  _createClass(IndentUsingClasses, [{
    key: "checkEnabled",
    value: function checkEnabled(indentAttributeValue) {
      var currentIndex = this.classes.indexOf(indentAttributeValue);

      if (this.isForward) {
        return currentIndex < this.classes.length - 1;
      } else {
        return currentIndex >= 0;
      }
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "getNextIndent",
    value: function getNextIndent(indentAttributeValue) {
      var currentIndex = this.classes.indexOf(indentAttributeValue);
      var indexStep = this.isForward ? 1 : -1;
      return this.classes[currentIndex + indexStep];
    }
  }]);

  return IndentUsingClasses;
}();

var DEFAULT_ELEMENTS = ['paragraph', 'heading1', 'heading2', 'heading3', 'heading4', 'heading5', 'heading6'];
/**
 * The block indentation feature.
 *
 * It registers the `'indentBlock'` and `'outdentBlock'` commands.
 *
 * If the plugin {@link module:indent/indent~Indent} is defined, it also attaches the `'indentBlock'` and `'outdentBlock'` commands to
 * the `'indent'` and `'outdent'` commands.
 */

var IndentBlock = /*#__PURE__*/function (_Plugin4) {
  _inherits(IndentBlock, _Plugin4);

  var _super5 = _createSuper(IndentBlock);

  /**
  * @inheritDoc
  */
  function IndentBlock(editor) {
    var _this5;

    _classCallCheck(this, IndentBlock);

    _this5 = _super5.call(this, editor);
    editor.config.define('indentBlock', {
      offset: 40,
      unit: 'px'
    });
    return _this5;
  }
  /**
  * @inheritDoc
  */


  _createClass(IndentBlock, [{
    key: "init",
    value:
    /**
    * @inheritDoc
    */
    function init() {
      var editor = this.editor;
      var configuration = editor.config.get('indentBlock');

      if (configuration.classes && configuration.classes.length) {
        this._setupConversionUsingClasses(configuration.classes);

        editor.commands.add('indentBlock', new IndentBlockCommand(editor, new IndentUsingClasses({
          direction: 'forward',
          classes: configuration.classes
        })));
        editor.commands.add('outdentBlock', new IndentBlockCommand(editor, new IndentUsingClasses({
          direction: 'backward',
          classes: configuration.classes
        })));
      } else {
        editor.data.addStyleProcessorRules(addMarginRules);

        this._setupConversionUsingOffset();

        editor.commands.add('indentBlock', new IndentBlockCommand(editor, new IndentUsingOffset({
          direction: 'forward',
          offset: configuration.offset,
          unit: configuration.unit
        })));
        editor.commands.add('outdentBlock', new IndentBlockCommand(editor, new IndentUsingOffset({
          direction: 'backward',
          offset: configuration.offset,
          unit: configuration.unit
        })));
      }
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "afterInit",
    value: function afterInit() {
      var editor = this.editor;
      var schema = editor.model.schema;
      var indentCommand = editor.commands.get('indent');
      var outdentCommand = editor.commands.get('outdent'); // Enable block indentation to heading configuration options. If it is not defined enable in paragraph and default headings.

      var options = editor.config.get('heading.options');
      var configuredElements = options && options.map(function (option) {
        return option.model;
      });
      var knownElements = configuredElements || DEFAULT_ELEMENTS;
      knownElements.forEach(function (elementName) {
        if (schema.isRegistered(elementName)) {
          schema.extend(elementName, {
            allowAttributes: 'blockIndent'
          });
        }
      });
      schema.setAttributeProperties('blockIndent', {
        isFormatting: true
      });
      indentCommand.registerChildCommand(editor.commands.get('indentBlock'));
      outdentCommand.registerChildCommand(editor.commands.get('outdentBlock'));
    }
    /**
    * Setups conversion for using offset indents.
    */

  }, {
    key: "_setupConversionUsingOffset",
    value: function _setupConversionUsingOffset() {
      var conversion = this.editor.conversion;
      var locale = this.editor.locale;
      var marginProperty = locale.contentLanguageDirection === 'rtl' ? 'margin-right' : 'margin-left';
      conversion.for('upcast').attributeToAttribute({
        view: {
          styles: _defineProperty({}, marginProperty, /[\s\S]+/)
        },
        model: {
          key: 'blockIndent',
          value: function value(viewElement) {
            // Do not indent block elements in Document Lists. See https://github.com/ckeditor/ckeditor5/issues/12466.
            if (!viewElement.is('element', 'li')) {
              return viewElement.getStyle(marginProperty);
            }
          }
        }
      });
      conversion.for('downcast').attributeToAttribute({
        model: 'blockIndent',
        view: function view(modelAttributeValue) {
          return {
            key: 'style',
            value: _defineProperty({}, marginProperty, modelAttributeValue)
          };
        }
      });
    }
    /**
    * Setups conversion for using classes.
    */

  }, {
    key: "_setupConversionUsingClasses",
    value: function _setupConversionUsingClasses(classes) {
      var definition = {
        model: {
          key: 'blockIndent',
          values: []
        },
        view: {}
      };

      var _iterator2 = _createForOfIteratorHelper(classes),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var className = _step2.value;
          definition.model.values.push(className);
          definition.view[className] = {
            key: 'class',
            value: [className]
          };
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.editor.conversion.attributeToAttribute(definition);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return 'IndentBlock';
    }
  }]);

  return IndentBlock;
}(Plugin);

export { Indent, IndentBlock, IndentEditing, IndentUI };